import React, { useEffect, useState } from "react";

import * as S from "./styles";
import { BoldTitle, FH, Text, Title } from "../../main-styles";
import WhiteBox from "../../../components/WhiteBox";
import { Col4grid } from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBasketShopping,
  faBox,
  faCoin,
  faFlagCheckered,
  faGift,
  faPaperPlane,
  faSensorAlert,
  faTimer,
  faTruck,
  faUmbrella,
  faUsers,
} from "@fortawesome/pro-light-svg-icons";
import { STEPS } from "../../../components/Stepper";
import { Spinner } from "reactstrap";
import { getDashboardData } from "../../../api/utils";

function Dashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    setUpdating(true);
    let ndata = await getDashboardData();
    setData(ndata);
    setLoading(false);
    setUpdating(false);
  }

  if (loading) {
    return (
      <S.Container style={{ marginTop: 20 }}>
        <Spinner />
      </S.Container>
    );
  }

  const {
    sums,
    visaoGeral,
    topDistribuidoresPedidos,
    topDistribuidoresValores,
    topGestoresSLA,
    topGestoresProdutos,
  } = data || {};

  return (
    <S.Container>
      <Title style={{ marginTop: 20 }}>Dashboard</Title>
      <WhiteBox>
        <BoldTitle>Visão Geral</BoldTitle>
        <FH style={{ justifyContent: "space-evenly", flexWrap: "wrap" }}>
          {STEPS.map((item, index) => {
            const valor = visaoGeral[item.toLowerCase()] || 0;
            return <BigNumber key={index} title={item} value={`${valor}`} />;
          })}
        </FH>
      </WhiteBox>
      <Col4grid>
        <WhiteBox>
          <BigNumber
            title="Total de Usuários"
            value={
              <div>
                <FontAwesomeIcon icon={faUsers} style={{ marginRight: 10 }} />
                {sums.total_users || 0}
              </div>
            }
          />
        </WhiteBox>
        <WhiteBox>
          <BigNumber
            title="Total de Pedidos"
            value={
              <div>
                <FontAwesomeIcon icon={faTruck} style={{ marginRight: 10 }} />
                {sums.total_pedidos || 0}
              </div>
            }
          />
        </WhiteBox>
        <WhiteBox>
          <BigNumber
            title="Total de Produtos"
            value={
              <div>
                <FontAwesomeIcon
                  icon={faUmbrella}
                  style={{ marginRight: 10 }}
                />
                {sums.total_produtos || 0}
              </div>
            }
          />
        </WhiteBox>
        <WhiteBox>
          <BigNumber
            title="Total de Vendas"
            value={
              <div>
                <FontAwesomeIcon icon={faCoin} />{" "}
                {sums.total_vendas_dinheiro || 0}
              </div>
            }
          />
        </WhiteBox>
        <WhiteBox>
          <BigNumber
            title="Total de Produtos Vendidos"
            value={
              <div>
                <FontAwesomeIcon icon={faGift} style={{ marginRight: 10 }} />
                {sums.total_vendas_produto || 0}
              </div>
            }
          />
        </WhiteBox>
        <WhiteBox>
          <BigNumber
            title="Total de Pedidos Pendentes"
            value={
              <div>
                <FontAwesomeIcon
                  icon={faSensorAlert}
                  style={{ marginRight: 10 }}
                />
                {sums.total_pedidos_pendentes || 0}
              </div>
            }
          />
        </WhiteBox>
        <WhiteBox>
          <BigNumber
            title="Aguardando Entrega"
            value={
              <div>
                <FontAwesomeIcon
                  icon={faFlagCheckered}
                  style={{ marginRight: 10 }}
                />
                {sums.total_pedidos_enviados || 0}
              </div>
            }
          />
        </WhiteBox>
        <WhiteBox>
          <BigNumber
            title="Aguardando Envio"
            value={
              <div>
                <FontAwesomeIcon
                  icon={faPaperPlane}
                  style={{ marginRight: 10 }}
                />
                {sums.total_pedidos_outros || 0}
              </div>
            }
          />
        </WhiteBox>
        <WhiteBox>
          <Title>Top Distribuidores ($)</Title>
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Distribuidor</th>
                <th style={{ textAlign: "right" }}>Vendas</th>
              </tr>
            </thead>
            <tbody>
              {topDistribuidoresValores.map((item, index) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td style={{ textAlign: "right" }}>
                    <FontAwesomeIcon icon={faCoin} style={{ marginRight: 5 }} />
                    {item.total_vendas}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </WhiteBox>
        <WhiteBox>
          <Title>Top Distribuidores (Volume)</Title>
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Distribuidor</th>
                <th style={{ textAlign: "right" }}>Vendas</th>
              </tr>
            </thead>
            <tbody>
              {topDistribuidoresPedidos.map((item, index) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td style={{ textAlign: "right" }}>
                    <FontAwesomeIcon icon={faBox} style={{ marginRight: 5 }} />
                    {item.total_pedidos}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </WhiteBox>
        <WhiteBox>
          <Title>Top Gestores (SLA)</Title>
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Gestor</th>
                <th style={{ textAlign: "right" }}>SLA</th>
              </tr>
            </thead>
            <tbody>
              {topGestoresSLA.map((item, index) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td style={{ textAlign: "right" }}>
                    <FontAwesomeIcon
                      icon={faTimer}
                      style={{ marginRight: 5 }}
                    />
                    {item.tempo_formatado_pendente_criado}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </WhiteBox>
        <WhiteBox>
          <Title>Top Gestores (Produtos)</Title>
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Gestor</th>
                <th style={{ textAlign: "right" }}>QTD</th>
              </tr>
            </thead>
            <tbody>
              {topGestoresProdutos.map((item, index) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td style={{ textAlign: "right" }}>
                    <FontAwesomeIcon
                      icon={faBasketShopping}
                      style={{ marginRight: 5 }}
                    />
                    {item.total_produtos}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </WhiteBox>
      </Col4grid>
    </S.Container>
  );
}

function BigNumber({ title, value }) {
  return (
    <S.BigNumber>
      <Title>{title}</Title>
      <span>{value}</span>
    </S.BigNumber>
  );
}

export default Dashboard;
